import React, { useState } from 'react';
import { useComponents } from '@tencent/dz-elements';
import { MessageMsgType } from '@tencent/dz-models';
import { ServerMsgContainer, ImagePreviewModal } from '../../../components';
import { useMessageById } from '../../../hooks';
import { formatRichText, formateImageWebp, clickRichText } from '../../../utils';
import RobotAnswers from './RobotAnswer';
import QuickReply from './QuickReply';
import StaffOption from './StaffOption';
import styles from './style/index.less';
var ServerMessage = function (props) {
    var _a;
    var messageId = props.messageId;
    var _b = useComponents(), Image = _b.Image, View = _b.View;
    var messageState = useMessageById(messageId);
    var msgType = messageState.msg_type;
    var _c = messageState.payload, _d = _c.img, img = _d === void 0 ? '' : _d, answers = _c.answers, message = _c.message, _e = _c.recommend, recommend = _e === void 0 ? {} : _e, staffWx = _c.staff_wx, staffTel = _c.staff_tel, _f = _c.disabled, disabled = _f === void 0 ? false : _f;
    var _g = useState(false), showImagePreview = _g[0], setShowImagePreview = _g[1];
    var _h = useState(''), previewImage = _h[0], setPreviewImage = _h[1];
    var onShowPreview = function (image) {
        setPreviewImage(image);
        setShowImagePreview(true);
    };
    var onHidePreview = function () {
        setShowImagePreview(false);
    };
    var renderMessage = function () {
        switch (msgType) {
            case MessageMsgType.Rich:
                return React.createElement("div", { className: styles['server-rich'], dangerouslySetInnerHTML: { __html: formatRichText(message) }, onClick: clickRichText('IMG', function (target) { return onShowPreview(target === null || target === void 0 ? void 0 : target.src); }) });
            case MessageMsgType.Image:
                return React.createElement(Image, { src: formateImageWebp(message), imageWidth: 100, imageHeight: 100, className: styles['msg-img'], onClick: function () { return onShowPreview(message); } });
            default:
                return React.createElement(View, { className: styles['msg-pre'] }, message);
        }
    };
    return (React.createElement(View, null,
        img && React.createElement(Image, { src: formateImageWebp(img), imageHeight: 345, imageWidth: 345, style: { marginBottom: 5 } }),
        React.createElement(ServerMsgContainer, null,
            renderMessage(),
            answers && answers.length > 0 && React.createElement(RobotAnswers, { answers: answers, disabled: disabled })),
        React.createElement(QuickReply, { replies: (_a = recommend === null || recommend === void 0 ? void 0 : recommend.quickReply) === null || _a === void 0 ? void 0 : _a.msgOptionList, messageId: messageId }),
        React.createElement(StaffOption, { staffTel: staffTel, staffWx: staffWx }),
        showImagePreview && (React.createElement(ImagePreviewModal, { images: [previewImage], onHide: onHidePreview, defaultIndex: 0 }))));
};
export default ServerMessage;
